import {
  promisify1z0ncraq1ipzh as promisify,
  await3n7kedgocftsv as await_0,
} from './IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../js/void.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from '../Continuation.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_continuationSymbol() {
  _init_properties_coroutinesInteropJs_kt__7auttl();
  return continuationSymbol;
}
var continuationSymbol;
function orPromise(continuation, lambda) {
  _init_properties_coroutinesInteropJs_kt__7auttl();
  if (continuation != VOID && continuation[get_continuationSymbol()]) {
    return lambda(continuation);
  } else {
    return promisify(lambda);
  }
}
function *$(value, $completion) {
  if (value.constructor === Promise) {
    return yield* await_0(value, $completion);
  } else {
    return yield* value;
  }
}
var properties_initialized_coroutinesInteropJs_kt_p4nog5;
function _init_properties_coroutinesInteropJs_kt__7auttl() {
  if (!properties_initialized_coroutinesInteropJs_kt_p4nog5) {
    properties_initialized_coroutinesInteropJs_kt_p4nog5 = true;
    // Inline function 'kotlin.js.asDynamic' call
    continuationSymbol = Continuation().Symbol;
  }
}
//region block: exports
export {
  $ as $3l5vvh8yg0ier,
  orPromise as orPromise1iucc2to2udt2,
};
//endregion

//# sourceMappingURL=coroutinesInteropJs.mjs.map
